import { Skeleton, Select, Input } from "antd";

export default function IngredientInputSkeleton() {
  return (
    <section className="flex space-x-3">
      <div className="w-[204px] h-[32px]">
        <Select name="itemName" style={{ width: "100%", height: "100%" }} />
      </div>
      <div className="w-[80px] h-[32px]">
        <Input type="number" name="itemQty" className="w-full h-full" placeholder="Qty" />
      </div>
      <div className="w-[123px] h-[32px]">
        <Select disabled name="itemUnit" style={{ width: "100%", height: "100%" }} options={[]} />
      </div>
      <div className="w-[108px] h-[32px]">
        <Input disabled type="number" name="cost" className="w-full h-full" placeholder="Unit price" />
      </div>
    </section>
  );
}
